/**
 * Shared i18n Resources
 * Exports all shared translation resources
 */

// English resources
import commonEn from './en/common.json';
import validationEn from './en/validation.json';
import errorsEn from './en/errors.json';

// Ukrainian resources
import commonUk from './uk/common.json';
import validationUk from './uk/validation.json';
import errorsUk from './uk/errors.json';

export const sharedResources = {
  en: {
    common: commonEn,
    validation: validationEn,
    errors: errorsEn,
  },
  uk: {
    common: commonUk,
    validation: validationUk,
    errors: errorsUk,
  },
};

export default sharedResources;

